import { Component, Input, OnInit } from '@angular/core';
import { Event, Router } from '@angular/router';
import { EventModel } from '../../models/event.model';
import { AlertService } from '../../services/alert.service';
import { EventsService } from '../../services/events.service';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss'],
})
export class CardsComponent implements OnInit {
  isLogged;
  @Input() card: EventModel;
  events: EventModel[];
  // jugadores: Player[];

  constructor(
    public alerta: AlertService,
    private eventsService: EventsService,
    private router: Router,
    private authService: LoginService
  ) {}

  ngOnInit() {
    this.isLogged = this.authService.estaAutenticado();
  }

  deleteEvent(eventId) {
    this.alerta.deleteEvent(eventId).then(() => {});
  }

  updateEvent(eventId) {
    this.router.navigate(['event-update', eventId]);
  }
}
